import { API_URLS } from "../Constants/api.constants";
import api from "./api";
import { errorHandling } from "./error.handling";

const basePath = `${API_URLS.TRANSPORTS}/paths`;

async function fetchPaths(companyId, pathId, purpose) {
  try {
    const params = new URLSearchParams();
    if (companyId) params.append("CompanyId", companyId);
    if (pathId) params.append("PathId", pathId);
    if (purpose) params.append("Purpose", purpose);

    const query = params.toString();
    const response = await api.get(`${basePath}${query ? `?${query}` : ""}`);

    const treated = errorHandling.handleResponse(
      response,
      "transportsPathsService.fetchPaths"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "transportsPathsService.fetchPaths");
    return null;
  }
}

async function savePath(payload) {
  try {
    const response = await api.post(basePath, JSON.stringify(payload));

    const treated = errorHandling.handleResponse(
      response,
      "transportsPathsService.savePath"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "transportsPathsService.savePath");
    return {
      error: true,
      status: error?.response?.status,
      message: error?.response?.data?.message,
      validations: error?.response?.data?.validations,
    };
  }
}

async function deletePath(companyId, pathId) {
  try {
    const params = new URLSearchParams({ CompanyId: companyId, PathId: pathId });
    const response = await api.delete(`${basePath}?${params.toString()}`);

    if (response.status === 204) {
      return { success: true };
    }

    const treated = errorHandling.handleResponse(
      response,
      "transportsPathsService.deletePath"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "transportsPathsService.deletePath");
    return null;
  }
}

export const transportsPathsService = {
  fetchPaths,
  savePath,
  deletePath,
};
